import React from 'react';
import { StyleSheet, View } from 'react-native';
import ExpressiveSmText from 'shared/components/vxl/typography/expressive/ExpressiveSmText';
import theme from 'shared/styles/theme';

interface PageTitleProps {
  titleText: string;
}

const PageTitle = ({ titleText }: PageTitleProps) => {
  return (
    <View style={baseHeaderStyles.header}>
      <ExpressiveSmText testID="page-title" numberOfLines={1}>
        {titleText}
      </ExpressiveSmText>
    </View>
  );
};

const baseHeaderStyles = StyleSheet.create({
  header: {
    backgroundColor: theme.color.background.primary,
    padding: theme.spacing.m,
    paddingBottom: theme.spacing.s,
  },
});

export default PageTitle;
